import { render } from "./classement_view_tab.vue?vue&type=template&id=493e1868"
import script from "./classement_view_tab.vue?vue&type=script&lang=js"
export * from "./classement_view_tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__